var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-explore-new-projects" }, [
    _c(
      "div",
      { staticClass: "o-width-limiter--full" },
      [
        _c("h2", { staticClass: "c-explore-new-projects__heading" }, [
          _vm._v("\n    " + _vm._s(_vm.parsedHeading) + "\n  "),
        ]),
        _vm._v(" "),
        _vm.mappedItems.length > 0
          ? _c(
              "slide-list",
              {
                staticClass: "c-explore-new-projects__carousel",
                attrs: {
                  id: _vm.id,
                  "data-slider-selector": ".slider",
                  "data-button-previous-selector": "",
                  "data-button-next-selector": "",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "slider" },
                  _vm._l(_vm.mappedItems, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: `project-${index}`,
                        staticClass: "slider__item",
                        attrs: { id: `${_vm.id}-item-${index}` },
                      },
                      [
                        item.variant === "object"
                          ? [
                              _c("v-object", {
                                attrs: {
                                  url: item.url,
                                  title: item.title,
                                  address: item.address,
                                  images: item.images,
                                  image: item.image,
                                  "size-from": item.sizeFrom,
                                  "size-to": item.sizeTo,
                                  "premise-types": item.premiseTypes,
                                  "icon-label": item.iconLabel,
                                  "number-of-workplaces":
                                    item.numberOfWorkplaces,
                                  "min-number-of-workplaces":
                                    item.minNumberOfWorkplaces,
                                  "max-number-of-workplaces":
                                    item.maxNumberOfWorkplaces,
                                  "price-per-square": item.pricePerSquare,
                                  city: item.city,
                                  district: item.district,
                                  features: item.features,
                                  "selected-features": item.selectedFeatures,
                                  "overflow-features-count":
                                    item.overflowFeaturesCount,
                                  "show-navigation": true,
                                  "show-buttons": true,
                                },
                              }),
                            ]
                          : item.variant === "card"
                          ? [
                              _c("v-object-card", {
                                attrs: {
                                  url: item.url,
                                  title: item.title,
                                  address: item.address,
                                  images: item.images,
                                  image: item.image,
                                  "size-from": item.sizeFrom,
                                  "size-to": item.sizeTo,
                                  "premise-types": item.premiseTypes,
                                  "icon-label": item.iconLabel,
                                  "number-of-workplaces":
                                    item.numberOfWorkplaces,
                                  "min-number-of-workplaces":
                                    item.minNumberOfWorkplaces,
                                  "max-number-of-workplaces":
                                    item.maxNumberOfWorkplaces,
                                  "price-per-square": item.pricePerSquare,
                                  city: item.city,
                                  district: item.district,
                                  features: item.features,
                                  "selected-features": item.selectedFeatures,
                                  "overflow-features-count":
                                    item.overflowFeaturesCount,
                                  "show-navigation": true,
                                  "show-buttons": true,
                                },
                              }),
                            ]
                          : item.variant === "puff"
                          ? [
                              _c("v-object-puff", {
                                attrs: {
                                  "project-image": item.projectImage,
                                  "project-title": item.projectTitle,
                                  "project-description":
                                    item.projectDescription,
                                  "project-cta-link": item.projectCtaLink,
                                  "project-cta-text": item.projectCtaText,
                                },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.mappedItems.length > 0
          ? _c("div", { staticClass: "c-explore-new-projects__bottom-bar" }, [
              _c(
                "div",
                { staticClass: "c-explore-new-projects__nav-controls" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "c-explore-new-projects__nav-arrow c-explore-new-projects__nav-arrow--prev",
                      attrs: {
                        disabled: _vm.currentPage === 0,
                        "aria-label": "Previous project",
                      },
                      on: { click: _vm.previousPage },
                    },
                    [
                      _c("i", {
                        staticClass:
                          "fa-regular fa-arrow-left c-explore-new-projects__nav-arrow-icon",
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "c-explore-new-projects__pagination",
                      attrs: {
                        role: "presentation",
                        "aria-label": "Projects pagination",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "c-explore-new-projects__progress",
                          on: { click: _vm.handleProgressClick },
                        },
                        [
                          _c("div", {
                            staticClass:
                              "c-explore-new-projects__progress-fill",
                            style: _vm.progressStyle,
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "c-explore-new-projects__nav-arrow c-explore-new-projects__nav-arrow--next",
                      attrs: {
                        disabled: _vm.currentPage === _vm.totalPages - 1,
                        "aria-label": "Next project",
                      },
                      on: { click: _vm.nextPage },
                    },
                    [
                      _c("i", {
                        staticClass:
                          "fa-regular fa-arrow-right c-explore-new-projects__nav-arrow-icon",
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.parsedButtonLink && _vm.parsedButtonText
                ? _c("div", { staticClass: "c-explore-new-projects__footer" }, [
                    _c(
                      "a",
                      {
                        staticClass: "c-explore-new-projects__cta-button",
                        attrs: { href: _vm.parsedButtonLink },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.parsedButtonText) +
                            "\n      "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }